import React from "react";
import { AdminPanelSettings as AdminPanelSettingsIcon } from "@mui/icons-material";
import { ClaimsAccessGrid } from "../grids";
import { SectionPaper, SectionHeader } from "../../../common/components/styled-ui-elements";

interface ClaimsAccessSectionProps {
  claims: any[];
  availableClaims: any[];
  onAddClaim?: (claim: { value: string; name: string }) => void;
  onDeleteClaim?: (claim: { value: string; name: string }) => void;
}

export const ClaimsAccessSection: React.FC<ClaimsAccessSectionProps> = ({
  claims,
  availableClaims,
  onAddClaim,
  onDeleteClaim,
}) => (
  <SectionPaper sx={{ p: 1.5, flex: 1 }}>
    <SectionHeader icon={<AdminPanelSettingsIcon sx={{ mr: 0.5 }} />} title="Claims Access" />
    <ClaimsAccessGrid
      claimsAccess={claims}
      availableClaims={availableClaims}
      onAdd={onAddClaim}
      onDelete={onDeleteClaim}
    />
  </SectionPaper>
);